export default () => ({
  status: {
    error: '',
  },
  leasingCompanies: [],
});
